import React, { useEffect, useState, useRef } from 'react'
import { Modal, Row, Typography, Card, Col, Form, Space, Button } from 'antd'
import InputMask from 'react-input-mask'
import { EmailGlobalHeader, GlobalFooter, EmptyHeaderHero } from './components'
import { useRouter } from 'next/router'

const { Title, Text } = Typography

const EmailSignUp = () => {
  const router = useRouter();

  const [phoneNumber, setPhoneNumber] = useState('')
  const [policyNumber, setPolicyNumber] = useState('')
  const [state, setState] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setPolicyNumber(router.query.policyNumber)
    setState(router.query.state)
  },[])

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validateInputs = (phoneNumber) => {
    console.log(phoneNumber)
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    console.log(policyNumber === undefined || state === undefined)
    return formatPhoneNumber(updatedNumber).length < 10
  }

  const handleSubmit = async () => {
    const newWindow = window.open(`/g/email-signup-result?phoneNumber=${phoneNumber}&policyNumber=${router.query.policyNumber}&state=${router.query.state}`, '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <EmailGlobalHeader />
      <EmptyHeaderHero
        minHeight={true}
        title='Want to stay in the loop?'
      />
      <div className="change-address vh-71">
        <Row>
          <Card className="register-card">
            <p>Enter your cell phone number to sign up for text updates with important information about your policy.</p>
            <p className='email-sub-text padding-0'>Receive offers and content over text message. Message and data rates may apply. Reply STOP to opt-out at any time.<br />
              <a
                className="text-reset text-underline"
                onClick={showModal}
              >
                Terms & Conditions
              </a> </p><br />
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <div className="margin-bottom-14" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  <InputMask
                    className="input-text phone-number"
                    mask="(999) 999-9999"
                    onChange={event => {
                      setPhoneNumber(event.target.value)
                    }}
                    placeholder="Phone Number*"
                    value={phoneNumber}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Form.Item className="btn-control button-submit-form">
                <Space>
                  <Button className="register register-form-button" disabled={validateInputs(phoneNumber)} onClick={() => handleSubmit()}>
                    Sign Up
                  </Button>
                </Space>
              </Form.Item>
            </Row>
          </Card>
        </Row>
      </div>
      <Modal wrapClassName="signup" title="TERMS & CONDITIONS" cancelButtonProps={{ style: { display: 'none' } }} open={isModalOpen} onOk={handleOk} okText="OK">
        <p className='terms'>By clicking “Sign Up,” I consent to receive email, text or phone communication (including an automatic dialing system or pre-recorded voice) at the home or mobile number provided for policy information, documents and other related notices. Messaging and data rates may apply. Text STOP at any time to opt-out.</p>
      </Modal>
      <GlobalFooter />
    </>
  )
}

EmailSignUp.propTypes = {}

export default EmailSignUp
